module.exports = __webpack_public_path__ + "img/lite-beach.ef11bba3.jpg";